import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import NotFoundPage from "../../../shared/404";
import StyledTabs from "../../../shared/Tabs/StyledTabs";
import TabTitle from "../../../shared/Tabs/TabTitle";
import AdminUsers from "./AdminUsers";
import JobsBoard from "../Jobs/JobsBoard";

export const ADMIN_BASE = "/admin";
const TABS = ["users", "jobs"];

/**
 * Super-admin hub: one page, one tab per admin tool. The active tab lives in
 * the URL (/admin/users, /admin/jobs, /admin/jobs/:jobKey) so tabs and job
 * deep links are bookmarkable. Hides the UI only; the API enforces
 * ROLE_SUPER_ADMIN on every endpoint behind these tabs.
 */
const AdminPage = () => {
  const { settings } = useContext(SettingsContext);
  const navigate = useNavigate();
  // /admin/:tab, or /admin/jobs/:jobKey which carries no :tab of its own.
  const { tab, jobKey } = useParams();

  if (!settings?.user?.roles) return null;

  const roles = Object.values(settings.user.roles);
  if (!roles.includes("ROLE_SUPER_ADMIN")) return <NotFoundPage />;

  const activeTab = TABS.includes(tab) ? tab : jobKey ? "jobs" : TABS[0];

  return (
    <div className="flex-fill">
      {/* key remounts StyledTabs when the URL changes (back button, deep link),
          since it only reads defaultKey on mount. mountOnEnter keeps the
          inactive tab from firing its requests. */}
      <StyledTabs
        key={activeTab}
        defaultKey={activeTab}
        handleKeyChange={(k) => navigate(`${ADMIN_BASE}/${k}`)}
      >
        <Tab mountOnEnter eventKey="users" title={<TabTitle icon="uil-users-alt" label="Users" />}>
          <div style={{ marginTop: 24 }} />
          <AdminUsers />
        </Tab>

        <Tab mountOnEnter eventKey="jobs" title={<TabTitle icon="uil-cog" label="Jobs" />}>
          <div style={{ marginTop: 24 }} />
          <JobsBoard basePath={`${ADMIN_BASE}/jobs`} />
        </Tab>
      </StyledTabs>
    </div>
  );
};

export default AdminPage;
